// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Organisation-profile statements — Sprint 62.53.0 (owner rulings #662, #665).
 *
 * A statement is what an organisation says about one RECORDED profile attribute
 * (`ORG_PROFILE_ATTRIBUTES[...].statement === 'recorded'`), with evidence, an
 * author and a time. Statements are append-only in `grc_org_profile_statements`
 * (one row per revision, unique `(org_id, attribute, revision)`); the current
 * statement is the highest revision and every earlier one is kept.
 *
 * Only the operator's own statement writes a profile value
 * (`PATCH /org-settings/profile-statements/:attribute`). The platform never
 * derives a route or a role from any other record (R-46).
 */
export const ORG_PROFILE_STATEMENTS_COLLECTION = 'grc_org_profile_statements';
/**
 * - `selected` — one or more vocabulary values apply. Resolves `stated`.
 * - `none` — none of the vocabulary applies. Resolves `stated_none`: a
 *   requirement conditioned on the attribute reads out of scope.
 * - `unknown` — the organisation does not know. Resolves `not_stated` with
 *   `declared_unknown`, raises an applicability review, and never excludes a
 *   requirement (#665).
 */
export const ORG_PROFILE_STATEMENT_STATES = ['selected', 'none', 'unknown'];
/** Bounds the PATCH enforces and the page states. */
export const ORG_PROFILE_STATEMENT_LIMITS = {
    evidence_file_ids: 20,
    note: 2000,
    history: 20,
};
/** The error codes the statement routes answer with, each a distinct case. */
export const ORG_PROFILE_STATEMENT_ERROR_CODES = {
    /** The attribute is not a recorded one (`sector`, or a name the registry does not hold). 400. */
    ATTRIBUTE_NOT_RECORDED: 'PROFILE_ATTRIBUTE_NOT_RECORDED',
    /** A value is not in the attribute's vocabulary. 400. */
    VALUE_OUTSIDE_VOCABULARY: 'PROFILE_VALUE_OUTSIDE_VOCABULARY',
    /** `expected_revision` is not the current revision: someone else saved first. 409. */
    REVISION_CONFLICT: 'PROFILE_STATEMENT_REVISION_CONFLICT',
    /** A named evidence file is not held by this organisation under this attribute. 422. */
    EVIDENCE_NOT_HELD: 'PROFILE_EVIDENCE_NOT_HELD',
};
//# sourceMappingURL=org-profile-statement.js.map